import React from "react"
import PropTypes from "prop-types"
import Button from "../shared/button/text-button"
import Tooltip from "../shared/tooltip/tooltip"
import { library } from "@fortawesome/fontawesome-svg-core"
import { faCheck } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as classnames from "classnames"

import "./swappable-benefit.scss"

library.add(faCheck)

// Component to display an individual Extra line with add/remove buttons
const SwappableBenefit = ({
  text,
  shortText,
  hoverText,
  onAddBenefit,
  onRemoveBenefit,
  id,
  selectedBenefitIDs,
  numberOfSwappableBenefits
}) => (
  <div
    className={classnames("swappable-benefit", {
      "disabled-benefit":
        numberOfSwappableBenefits === selectedBenefitIDs.length &&
        !selectedBenefitIDs.includes(id)
    })}
  >
    <div className="swappable-benefit--description">
      <div className="short-text">
        {shortText} {hoverText && <Tooltip text={hoverText} />}
      </div>
      {text && <div className="text">{text}</div>}
    </div>
    {selectedBenefitIDs.includes(id) ? (
      <div className="remove-benefit-button">
        <div className="added-message">
          <FontAwesomeIcon icon="check" /> Added
        </div>
        <div className="remove-link">
          <div onClick={() => onRemoveBenefit(id)}>Remove this benefit</div>
        </div>
      </div>
    ) : (
      <div className="add-benefit-button">
        <Button
          text="Add"
          onClick={() => {
            onAddBenefit(id)
          }}
        />
      </div>
    )}
  </div>
)

SwappableBenefit.propTypes = {
  text: PropTypes.string,
  shortText: PropTypes.string.isRequired,
  cost: PropTypes.number.isRequired,
  hoverText: PropTypes.string,
  onAddBenefit: PropTypes.func.isRequired,
  onRemoveBenefit: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  selectedBenefitIDs: PropTypes.arrayOf(PropTypes.string),
  excludeVAT: PropTypes.bool,
  numberOfSwappableBenefits: PropTypes.number
}

SwappableBenefit.defaultProps = {
  text: "",
  hoverText: "",
  selectedBenefitIDs: [],
  excludeVAT: false
}

export default SwappableBenefit
